const testimonials = [
  {
    name: "James H.",
    location: "Titusville, FL",
    rating: 5,
    text: "I'm a systems engineer supporting ISS payload integration out of KSC. Got called to a critical design review in Toulouse, France, with eleven days' notice — a mission milestone I couldn't miss. Pulled my passport and it was expired by six months due to the pandemic travel pause. Fast Passport Center processed my renewal in four business days. Made the review, the payload integration stayed on schedule, and I was back in Titusville in time for the next launch campaign. This is the only passport service I trust.",
    service: "Emergency Passport Renewal",
  },
  {
    name: "Sarah K.",
    location: "Mims, FL",
    rating: 5,
    text: "We booked a Royal Caribbean cruise out of Port Canaveral for our anniversary — first vacation in two years. Eight days before sailing, my husband realized his passport had expired. We were devastated thinking we'd lose thousands. Fast Passport Center expedited his renewal in three business days. We made the cruise, celebrated on the top deck watching the sunset over the Bahamas, and didn't lose a cent. Unbelievable turnaround.",
    service: "Expedited Passport Renewal",
  },
  {
    name: "Mike T.",
    location: "Port St. John, FL",
    rating: 5,
    text: "I'm a launch photographer credentialed at the Cape. A colleague and I got last-minute credentials for an Ariane 6 night launch in French Guiana — the kind of opportunity that defines a career. My passport was valid but had four months remaining and French Guiana requires six. Fast Passport Center expedited my renewal in three business days. Made the launch, captured the long-exposure night shots I'd been dreaming of, portfolio is now in a different league. I send every photographer I know to this service.",
    service: "Expedited Passport Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function TitusvilleTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Titusville Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Titusville aerospace engineers, cruise families, launch photographers, and lagoon enthusiasts who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}